export default $client => ({
  get(props) {
    return $client.get('settings')
  }
})
